(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["campaign-hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var TZ_FALLBACK = "Europe/Copenhagen";

    function tzOffsetMs(date, timeZone) {
      var dtf = new Intl.DateTimeFormat("en-US", {
        timeZone: timeZone,
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
        hour12: false
      });
      var parts = dtf.formatToParts(date).reduce(function (acc, p) {
        acc[p.type] = p.value;
        return acc;
      }, {});
      var asUTC = Date.UTC(
        Number(parts.year),
        Number(parts.month) - 1,
        Number(parts.day),
        Number(parts.hour),
        Number(parts.minute),
        Number(parts.second)
      );
      return asUTC - date.getTime();
    }

    function wallTimeToUtcMs(y, m, d, h, min, s, timeZone) {
      var naiveUTC = new Date(Date.UTC(y, m - 1, d, h, min, s));
      return naiveUTC.getTime() - tzOffsetMs(naiveUTC, timeZone);
    }

    function pad2(value) {
      return String(value).padStart(2, "0");
    }

    function initCountdown(root) {
      if (!root || root.dataset.countdownReady === "true") return;
      root.dataset.countdownReady = "true";

      var timeZone = root.dataset.timezone || TZ_FALLBACK;
      var targetUtcMs = wallTimeToUtcMs(
        Number(root.dataset.year),
        Number(root.dataset.month),
        Number(root.dataset.day),
        Number(root.dataset.hour),
        Number(root.dataset.minute),
        Number(root.dataset.second),
        timeZone
      );

      var serverNowMs = Number(root.dataset.serverNow) * 1000;
      var startPerf = typeof performance !== "undefined" && performance.now ? performance.now() : Date.now();

      function getNowMs() {
        var t = typeof performance !== "undefined" && performance.now ? performance.now() : Date.now();
        return serverNowMs + (t - startPerf);
      }

      var daysEl = root.querySelector('[data-unit="days"]');
      var hoursEl = root.querySelector('[data-unit="hours"]');
      var minsEl = root.querySelector('[data-unit="minutes"]');
      var secsEl = root.querySelector('[data-unit="seconds"]');
      var expiredEl = root.querySelector("[data-countdown-expired]");
      var hideExpired = root.dataset.hideExpired === "true";
      var designMode = root.dataset.designMode === "true";

      function setExpired() {
        if (daysEl) daysEl.textContent = "00";
        if (hoursEl) hoursEl.textContent = "00";
        if (minsEl) minsEl.textContent = "00";
        if (secsEl) secsEl.textContent = "00";

        if (expiredEl) {
          expiredEl.hidden = false;
          root.classList.add("is-expired");
        }

        if (hideExpired && !designMode) {
          root.style.display = "none";
        }
      }

      function updateCountdown() {
        var distance = targetUtcMs - getNowMs();

        if (distance <= 0) {
          setExpired();
          clearInterval(root._countdownInterval);
          return;
        }

        var days = Math.floor(distance / (1000 * 60 * 60 * 24));
        var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
        var seconds = Math.floor((distance % (1000 * 60)) / 1000);

        if (daysEl) daysEl.textContent = pad2(days);
        if (hoursEl) hoursEl.textContent = pad2(hours);
        if (minsEl) minsEl.textContent = pad2(minutes);
        if (secsEl) secsEl.textContent = pad2(seconds);
      }

      updateCountdown();
      root._countdownInterval = setInterval(updateCountdown, 1000);
    }

    function centerWebmOverlay(video) {
      var wrap = video.closest(".campaign-hero__middle--webm");
      if (!wrap) return;
      wrap.style.marginTop = -(video.offsetHeight / 2) + "px";
    }

    function prepareOverlayVideo(video) {
      video.muted = true;
      video.defaultMuted = true;
      video.loop = true;
      video.autoplay = true;
      video.preload = "auto";
      video.playsInline = true;
      video.playbackRate = 1;
      video.defaultPlaybackRate = 1;
      video.setAttribute("playsinline", "");
      video.setAttribute("webkit-playsinline", "");
      video.setAttribute("muted", "");
      var playPromise = video.play();
      if (playPromise && playPromise.catch) playPromise.catch(function () {});
    }

    function initMatteOverlay(wrap) {
      if (!wrap || wrap.dataset.alphaReady === "true") return;
      wrap.dataset.alphaReady = "true";

      var mode = wrap.getAttribute("data-overlay-alpha");
      var videos = wrap.querySelectorAll("video");
      var color = videos[0];
      var matte = wrap.querySelector("video.campaign-hero__overlay-matte");
      if (!matte && videos.length > 1) matte = videos[1];
      var canvas = wrap.querySelector("[data-overlay-canvas]");
      if (!color || !canvas || (mode !== "stacked" && mode !== "matte")) return;

      var ctx = canvas.getContext("2d", { alpha: true, willReadFrequently: true });
      if (!ctx) return;

      var running = true;
      var raf = 0;
      var live = false;

      function stop() {
        running = false;
        if (raf) cancelAnimationFrame(raf);
      }

      wrap._alphaStop = stop;

      function sizeCanvas() {
        var vw = color.videoWidth;
        var vh = color.videoHeight;
        if (!vw || !vh) return false;

        var srcH = mode === "stacked" ? vh / 2 : vh;
        var cssW = wrap.clientWidth || vw;
        var dpr = Math.min(window.devicePixelRatio || 1, 2);
        var pixelW = Math.max(1, Math.min(Math.round(cssW * dpr), 720));
        var pixelH = Math.max(1, Math.round(pixelW * (srcH / vw)));

        if (canvas.width !== pixelW || canvas.height !== pixelH) {
          canvas.width = pixelW;
          canvas.height = pixelH;
        }

        canvas.style.aspectRatio = vw + " / " + srcH;
        return true;
      }

      function composite() {
        if (!running) return;
        if (color.readyState < 2) return;
        if (mode === "matte" && matte && matte.readyState < 2) return;
        if (!sizeCanvas()) return;

        var w = canvas.width;
        var h = canvas.height;
        var vw = color.videoWidth;
        var vh = color.videoHeight;

        try {
          if (mode === "stacked") {
            var half = vh / 2;
            ctx.drawImage(color, 0, 0, vw, half, 0, 0, w, h);
            var stackedFrame = ctx.getImageData(0, 0, w, h);
            ctx.drawImage(color, 0, half, vw, half, 0, 0, w, h);
            var stackedMask = ctx.getImageData(0, 0, w, h).data;
            var stackedData = stackedFrame.data;
            for (var i = 0; i < stackedData.length; i += 4) {
              var stackedA = stackedMask[i];
              stackedData[i + 3] = stackedA < 12 ? 0 : stackedA;
            }
            ctx.putImageData(stackedFrame, 0, 0);
          } else {
            ctx.drawImage(color, 0, 0, w, h);
            var frame = ctx.getImageData(0, 0, w, h);
            ctx.drawImage(matte, 0, 0, w, h);
            var mask = ctx.getImageData(0, 0, w, h).data;
            var data = frame.data;
            for (var j = 0; j < data.length; j += 4) {
              var a = mask[j];
              data[j + 3] = a < 12 ? 0 : a;
            }
            ctx.putImageData(frame, 0, 0);
          }

          if (!live) {
            live = true;
            canvas.hidden = false;
            wrap.classList.add("is-alpha-canvas");
          }
        } catch (err) {
          canvas.hidden = true;
          wrap.classList.remove("is-alpha-canvas");
        }
      }

      function tick() {
        if (!running) return;
        composite();
        if (color.requestVideoFrameCallback) {
          color.requestVideoFrameCallback(function () {
            tick();
          });
        } else {
          raf = requestAnimationFrame(tick);
        }
      }

      function syncMatte() {
        if (!matte) return;
        if (Math.abs(matte.currentTime - color.currentTime) > 0.08) {
          try {
            matte.currentTime = color.currentTime;
          } catch (err) {}
        }
      }

      if (matte) {
        prepareOverlayVideo(matte);
        color.addEventListener("timeupdate", syncMatte);
      }

      if (color.readyState >= 1) tick();
      else color.addEventListener("loadedmetadata", tick, { once: true });
    }

    function initOverlayVideos(scope) {
      var root = scope || document;

      root.querySelectorAll(".campaign-hero__top-asset video, .campaign-hero__middle video").forEach(function (video) {
        if (video.dataset.overlayReady === "true") return;
        video.dataset.overlayReady = "true";

        video.classList.add("is-active");
        prepareOverlayVideo(video);

        video.addEventListener("loadedmetadata", function () {
          centerWebmOverlay(video);
        });
        video.addEventListener("loadeddata", function () {
          centerWebmOverlay(video);
        });
        if (video.readyState >= 1) centerWebmOverlay(video);
      });

      root.querySelectorAll("[data-overlay-alpha]").forEach(initMatteOverlay);
    }

    function headerOffset() {
      var raw = getComputedStyle(document.documentElement).getPropertyValue("--header-group-height-static");
      var n = parseFloat(raw);
      return isNaN(n) ? 0 : n;
    }

    function initNavAnchors(scope) {
      var root = scope || document;
      root.querySelectorAll('.campaign-hero__nav-btn[href^="#"]').forEach(function (link) {
        if (link.dataset.navReady === "true") return;
        link.dataset.navReady = "true";
        link.addEventListener("click", function (event) {
          var id = (link.getAttribute("href") || "").replace("#", "");
          if (!id) return;
          var target = document.getElementById(id);
          if (!target) return;
          event.preventDefault();
          var top = target.getBoundingClientRect().top + window.pageYOffset - headerOffset();
          window.scrollTo({ top: Math.max(0, top), behavior: "smooth" });
        });
      });
    }

    function initAll(scope) {
      var root = scope || document;
      root.querySelectorAll("[data-campaign-countdown]").forEach(initCountdown);
      initOverlayVideos(root);
      initNavAnchors(root);
    }

    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", function () {
        initAll(document);
      });
    } else {
      initAll(document);
    }

    document.addEventListener("shopify:section:load", function (event) {
      initAll(event.target);
    });

    document.addEventListener("shopify:section:unload", function (event) {
      event.target.querySelectorAll("[data-overlay-alpha]").forEach(function (wrap) {
        if (wrap._alphaStop) wrap._alphaStop();
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["countdown-bar"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var TZ_FALLBACK = "Europe/Copenhagen";

    function tzOffsetMs(date, timeZone) {
      var dtf = new Intl.DateTimeFormat("en-US", {
        timeZone: timeZone,
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
        hour12: false
      });
      var parts = dtf.formatToParts(date).reduce(function (acc, p) {
        acc[p.type] = p.value;
        return acc;
      }, {});
      var asUTC = Date.UTC(
        Number(parts.year),
        Number(parts.month) - 1,
        Number(parts.day),
        Number(parts.hour),
        Number(parts.minute),
        Number(parts.second)
      );
      return asUTC - date.getTime();
    }

    function wallTimeToUtcMs(y, m, d, h, min, s, timeZone) {
      var naiveUTC = new Date(Date.UTC(y, m - 1, d, h, min, s));
      return naiveUTC.getTime() - tzOffsetMs(naiveUTC, timeZone);
    }

    function pad2(value) {
      return String(value).padStart(2, "0");
    }

    function initCountdown(root) {
      if (!root || root.dataset.countdownReady === "true") return;
      root.dataset.countdownReady = "true";

      var timeZone = root.dataset.timezone || TZ_FALLBACK;
      var targetUtcMs = wallTimeToUtcMs(
        Number(root.dataset.year),
        Number(root.dataset.month),
        Number(root.dataset.day),
        Number(root.dataset.hour),
        Number(root.dataset.minute),
        Number(root.dataset.second),
        timeZone
      );

      var serverNowMs = Number(root.dataset.serverNow) * 1000;
      var startPerf = typeof performance !== "undefined" && performance.now ? performance.now() : Date.now();

      function getNowMs() {
        var t = typeof performance !== "undefined" && performance.now ? performance.now() : Date.now();
        return serverNowMs + (t - startPerf);
      }

      var daysEl = root.querySelector('[data-unit="days"]');
      var hoursEl = root.querySelector('[data-unit="hours"]');
      var minsEl = root.querySelector('[data-unit="minutes"]');
      var secsEl = root.querySelector('[data-unit="seconds"]');
      var expiredEl = root.querySelector("[data-countdown-expired]");
      var hideExpired = root.dataset.hideExpired === "true";
      var designMode = root.dataset.designMode === "true";
      var sectionEl = root.closest(".shopify-section");

      function setExpired() {
        if (daysEl) daysEl.textContent = "0";
        if (hoursEl) hoursEl.textContent = "00";
        if (minsEl) minsEl.textContent = "00";
        if (secsEl) secsEl.textContent = "00";

        if (expiredEl) {
          expiredEl.hidden = false;
          root.classList.add("is-expired");
        }

        if (hideExpired && !designMode && sectionEl) {
          sectionEl.style.display = "none";
        }
      }

      function updateCountdown() {
        var distance = targetUtcMs - getNowMs();

        if (distance <= 0) {
          setExpired();
          clearInterval(root._countdownInterval);
          return;
        }

        var days = Math.floor(distance / (1000 * 60 * 60 * 24));
        var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
        var seconds = Math.floor((distance % (1000 * 60)) / 1000);

        if (daysEl) daysEl.textContent = String(days);
        if (hoursEl) hoursEl.textContent = pad2(hours);
        if (minsEl) minsEl.textContent = pad2(minutes);
        if (secsEl) secsEl.textContent = pad2(seconds);
      }

      updateCountdown();
      root._countdownInterval = setInterval(updateCountdown, 1000);
    }

    function initAll(scope) {
      var root = scope || document;
      root.querySelectorAll("[data-countdown-bar]").forEach(initCountdown);
    }

    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", function () {
        initAll(document);
      });
    } else {
      initAll(document);
    }

    document.addEventListener("shopify:section:load", function (event) {
      initAll(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-banner-hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function prepareOverlayVideo(video) {
      video.muted = true;
      video.defaultMuted = true;
      video.loop = true;
      video.autoplay = true;
      video.preload = "auto";
      video.playsInline = true;
      video.playbackRate = 1;
      video.defaultPlaybackRate = 1;
      video.setAttribute("playsinline", "");
      video.setAttribute("webkit-playsinline", "");
      video.setAttribute("muted", "");
      var playPromise = video.play();
      if (playPromise && playPromise.catch) playPromise.catch(function () {});
    }

    function initMatteOverlay(wrap) {
      if (!wrap || wrap.dataset.alphaReady === "true") return;
      wrap.dataset.alphaReady = "true";

      var mode = wrap.getAttribute("data-overlay-alpha");
      var videos = wrap.querySelectorAll("video");
      var color = videos[0];
      var matte = wrap.querySelector("video.image_banner__overlay-matte");
      if (!matte && videos.length > 1) matte = videos[1];
      var canvas = wrap.querySelector("[data-overlay-canvas]");
      if (!color || !canvas || (mode !== "stacked" && mode !== "matte")) return;

      var ctx = canvas.getContext("2d", { alpha: true, willReadFrequently: true });
      if (!ctx) return;

      var running = true;
      var raf = 0;
      var live = false;

      function stop() {
        running = false;
        if (raf) cancelAnimationFrame(raf);
      }

      wrap._alphaStop = stop;

      function sizeCanvas() {
        var vw = color.videoWidth;
        var vh = color.videoHeight;
        if (!vw || !vh) return false;

        var srcH = mode === "stacked" ? vh / 2 : vh;
        var cssW = wrap.clientWidth || vw;
        var dpr = Math.min(window.devicePixelRatio || 1, 2);
        var pixelW = Math.max(1, Math.min(Math.round(cssW * dpr), 720));
        var pixelH = Math.max(1, Math.round(pixelW * (srcH / vw)));

        if (canvas.width !== pixelW || canvas.height !== pixelH) {
          canvas.width = pixelW;
          canvas.height = pixelH;
        }

        canvas.style.aspectRatio = vw + " / " + srcH;
        return true;
      }

      function composite() {
        if (!running) return;
        if (color.readyState < 2) return;
        if (mode === "matte" && matte && matte.readyState < 2) return;
        if (!sizeCanvas()) return;

        var w = canvas.width;
        var h = canvas.height;
        var vw = color.videoWidth;
        var vh = color.videoHeight;

        try {
          if (mode === "stacked") {
            var half = vh / 2;
            ctx.drawImage(color, 0, 0, vw, half, 0, 0, w, h);
            var stackedFrame = ctx.getImageData(0, 0, w, h);
            ctx.drawImage(color, 0, half, vw, half, 0, 0, w, h);
            var stackedMask = ctx.getImageData(0, 0, w, h).data;
            var stackedData = stackedFrame.data;
            for (var i = 0; i < stackedData.length; i += 4) {
              var stackedA = stackedMask[i];
              stackedData[i + 3] = stackedA < 12 ? 0 : stackedA;
            }
            ctx.putImageData(stackedFrame, 0, 0);
          } else {
            ctx.drawImage(color, 0, 0, w, h);
            var frame = ctx.getImageData(0, 0, w, h);
            ctx.drawImage(matte, 0, 0, w, h);
            var mask = ctx.getImageData(0, 0, w, h).data;
            var data = frame.data;
            for (var j = 0; j < data.length; j += 4) {
              var a = mask[j];
              data[j + 3] = a < 12 ? 0 : a;
            }
            ctx.putImageData(frame, 0, 0);
          }

          if (!live) {
            live = true;
            canvas.hidden = false;
            wrap.classList.add("is-alpha-canvas");
          }
        } catch (err) {
          canvas.hidden = true;
          wrap.classList.remove("is-alpha-canvas");
        }
      }

      function tick() {
        if (!running) return;
        composite();
        if (color.requestVideoFrameCallback) {
          color.requestVideoFrameCallback(function () {
            tick();
          });
        } else {
          raf = requestAnimationFrame(tick);
        }
      }

      function syncMatte() {
        if (!matte) return;
        if (Math.abs(matte.currentTime - color.currentTime) > 0.08) {
          try {
            matte.currentTime = color.currentTime;
          } catch (err) {}
        }
      }

      if (matte) {
        prepareOverlayVideo(matte);
        color.addEventListener("timeupdate", syncMatte);
      }

      if (color.readyState >= 1) tick();
      else color.addEventListener("loadedmetadata", tick, { once: true });
    }

    function initOverlayVideos(scope) {
      var root = scope || document;

      root.querySelectorAll(".image_banner__top-asset video").forEach(function (video) {
        if (video.dataset.overlayReady === "true") return;
        video.dataset.overlayReady = "true";

        video.classList.add("is-active");
        prepareOverlayVideo(video);
      });

      root.querySelectorAll("[data-overlay-alpha]").forEach(initMatteOverlay);
    }

    function initAll(scope) {
      initOverlayVideos(scope || document);
    }

    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", function () {
        initAll(document);
      });
    } else {
      initAll(document);
    }

    document.addEventListener("shopify:section:load", function (event) {
      initAll(event.target);
    });

    document.addEventListener("shopify:section:unload", function (event) {
      event.target.querySelectorAll("[data-overlay-alpha]").forEach(function (wrap) {
        if (wrap._alphaStop) wrap._alphaStop();
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["seo-collections-grid"] && !Shopify.designMode) return;
  try {
    
(function () {
  function esc(str) {
    return String(str || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function formatMoney(cents) {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      return window.Shopify.formatMoney(cents);
    }
    return (cents / 100).toLocaleString(undefined, {
      minimumFractionDigits: 0,
      maximumFractionDigits: 2
    });
  }

  function findVariant(variants, colorLabel, colorRef) {
    if (!variants || !variants.length) return null;

    var label = (colorLabel || '').toLowerCase();
    var ref = (colorRef || '').toLowerCase();

    for (var i = 0; i < variants.length; i++) {
      var variant = variants[i];
      var option1 = (variant.option1 || '').toLowerCase();
      var option2 = (variant.option2 || '').toLowerCase();
      var option3 = (variant.option3 || '').toLowerCase();

      if (label && (option1 === label || option2 === label || option3 === label)) {
        return variant;
      }
    }

    if (/^\d+$/.test(ref)) {
      for (var j = 0; j < variants.length; j++) {
        if (String(variants[j].id) === ref) return variants[j];
      }
    }

    if (ref) {
      for (var k = 0; k < variants.length; k++) {
        var sku = (variants[k].sku || '').toLowerCase();
        if (sku.indexOf(ref) !== -1) return variants[k];
      }
    }

    if (label) {
      for (var l = 0; l < variants.length; l++) {
        var title = (variants[l].title || '').toLowerCase();
        if (title.indexOf(label) !== -1) return variants[l];
      }
    }

    return null;
  }

  function buildCard(product, variant, colorLabel) {
    var variantUrl = '/products/' + product.handle + '?variant=' + variant.id;
    var imageSrc =
      (variant.featured_image && variant.featured_image.src) ||
      (product.featured_image && product.featured_image) ||
      '';
    var imageHtml = imageSrc
      ? '<img src="' + esc(imageSrc) + '" loading="lazy" alt="' + esc(product.title) + '" class="card__media card__media-simple">'
      : '';

    return (
      '<li class="collection-products__grid__list__item seo-collection-variant-card">' +
        '<div class="card-wrapper product-card-wrapper product-center">' +
          '<div class="card product" data-product-card-id="' + esc(String(product.id)) + '" data-variant-id="' + esc(String(variant.id)) + '">' +
            '<div class="card__inner">' +
              (imageHtml
                ? '<div class="card__media relative overflow-hidden"><a href="' + esc(variantUrl) + '">' + imageHtml + '</a></div>'
                : '') +
            '</div>' +
            '<div class="card__content">' +
              '<div>' +
                '<div class="card__header"><div class="card__title"><a href="' + esc(variantUrl) + '">' + esc(product.title) + '</a></div></div>' +
                (colorLabel ? '<p class="seo-collection-variant-card__subtitle">' + esc(colorLabel) + '</p>' : '') +
                '<div class="card__price"><div class="price"><span class="price__regular">' + esc(formatMoney(variant.price)) + '</span></div></div>' +
              '</div>' +
            '</div>' +
          '</div>' +
        '</div>' +
      '</li>'
    );
  }

  function hydrateGrid(root) {
    var configEl = root.parentElement && root.parentElement.querySelector('[data-seo-grid-config]');
    if (!configEl) return;

    var config;
    try {
      config = JSON.parse(configEl.textContent);
    } catch (error) {
      return;
    }

    if (!config.items || !config.items.length) return;
    if (root.children.length > 0) return;

    Promise.all(
      config.items.map(function (item) {
        return fetch('/products/' + encodeURIComponent(item.handle) + '.js')
          .then(function (response) {
            return response.ok ? response.json() : null;
          })
          .catch(function () {
            return null;
          })
          .then(function (product) {
            if (!product) return '';
            var variant = findVariant(product.variants, item.colorLabel, item.colorRef);
            if (!variant) return '';
            return buildCard(product, variant, item.colorLabel);
          });
      })
    ).then(function (cards) {
      var html = cards.filter(Boolean).join('');
      if (html) root.innerHTML = html;
    });
  }

  function init() {
    document.querySelectorAll('[data-seo-grid-root]').forEach(hydrateGrid);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

  } catch(e) { console.error(e); }
})();
})();
